<script setup lang="ts">
import './assets/style.scss'
import { ref, watch } from 'vue'
import WInventoryMapinfoSelected from './WInventoryMapinfoSelected.vue'
import WInventoryMapInfoItem from '@/widgets/InventoryMapInfo/ui/WInventoryMapInfoItem.vue'
import { InventObjectReplaceForm } from '@/features/Inventory/ObjectReplace'
import { WInventoryLEPModal } from '@/widgets'
import type { InventoryMapInfoHeader } from '../model/types.ts'

const props = defineProps<{
  /** Шапки выбранных объектов — уже загружены картой, без отдельного запроса. */
  headers: InventoryMapInfoHeader[]
}>()

const selected = defineModel<number[]>({ default: [] })

const emits = defineEmits(['updateCoords', 'mapObjectFocused'])

/** Раскрываем сразу, только если выбран ровно один объект — как и раньше.
 *  Значения — id объектов (не индексы), чтобы каждая шапка могла сама узнать
 *  свою раскрытость и включить ленивую подгрузку данных. */
const openPanels = ref<number[]>([])
watch(
  () => props.headers,
  (headers) => {
    openPanels.value = headers.length === 1 ? [headers[0].id] : []
  },
  { immediate: true },
)

const updateSelectedHandler = (ids: number[]) => {
  selected.value = ids
}

const clearHandler = () => {
  selected.value = []
}

const deleteFromSelectedHandler = (id: number) => {
  selected.value = selected.value.filter((item) => item !== id)
}

const mapObjectFocusedHandler = (coordinates: number[][]) => {
  emits('mapObjectFocused', coordinates)
}
</script>

<template>
  <div v-if="headers.length" class="w-invent-map-info">
    <WInventoryMapinfoSelected :items="selected" @clear="clearHandler" />

    <VExpansionPanels v-model="openPanels" multiple>
      <WInventoryMapInfoItem
        v-for="header in headers"
        :key="header.id"
        :header
        :value="header.id"
        :is-open="openPanels.includes(header.id)"
        @update-selected="updateSelectedHandler"
        @update-coords="emits('updateCoords')"
        @delete-from-selected="deleteFromSelectedHandler"
        @map-object-focused="mapObjectFocusedHandler"
      />
    </VExpansionPanels>
  </div>

  <InventObjectReplaceForm />
  <WInventoryLEPModal />
</template>
